/** Amazon media-image URL helpers. Pure; inputs are never mutated. */
/** Amazon media CDN hosts whose paths accept the `_AC_` image directive. */
const AMAZON_MEDIA_HOSTS = ['m.media-amazon.com', 'images-amazon.com', 'images-na.ssl-images-amazon.com'];
/**
 * Rewrites an Amazon media URL to request the `_AC_` auto-cropped variant at `edge` px (like the CLP
 * cards), e.g. `.../ID.jpg` -> `.../ID._AC_UL300_SY300_QL70_.jpg`. Returns `url` unchanged when it is
 * empty, not an Amazon media host, has no extension, or already has an `_AC_` directive.
 */
export const withAutoCrop = (url, edge) => {
    if (!url) {
        return url;
    }
    let host;
    try {
        host = new URL(url).hostname;
    }
    catch (_a) {
        return url; // Not an absolute URL: leave it untouched.
    }
    const isAmazonMedia = AMAZON_MEDIA_HOSTS.some((h) => host === h || host.endsWith(`.${h}`));
    // Already auto-cropped: leave it (idempotent).
    if (!isAmazonMedia || url.includes('._AC')) {
        return url;
    }
    const directive = `._AC_UL${edge}_SY${edge}_QL70_`;
    // Replace any existing size directive (e.g. `._SL1500_`, `._SY450_`) so a master URL doesn't end
    // up with two stacked directives; otherwise inject ours just before the extension.
    const existingDirective = /\._[A-Za-z0-9_,]+_\.(\w+)(\?.*)?$/;
    if (existingDirective.test(url)) {
        return url.replace(existingDirective, `${directive}.$1$2`);
    }
    return url.replace(/\.(\w+)(\?.*)?$/, `${directive}.$1$2`);
};
